import React, { useState } from "react";
import { Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import { cancelAlgo } from "../../../../../store/actions/algo";

const CancelTargetListModal = ({ preview, algoId, selectedCompany, previewHandler }) => {
  // STATES
  const [cancelLoader, setCancelLoader] = useState(false);

  // REDUX DATA
  const companies = useSelector((state) => state.CompanyReducer.companies);

  // CONST VALS
  const { http } = global.services;
  const dispatch = useDispatch();
  const companyName = companies.find((c) => c.id == selectedCompany)?.company_name || "";

  const cancelHandler = () => {
    setCancelLoader(true);
    http
      .put("algo-status", {
        algoId: algoId,
      })
      .finally(() => setCancelLoader(false))
      .then(() => {
        toast.success("List cancelled successfully");
        dispatch(cancelAlgo({ companyId: selectedCompany }));
        previewHandler();
      })
      .catch((error) => {
        toast.error(error.message || "Something went wrong");
      });
  };

  return (
    <Modal
      visible={preview}
      centered
      className="delete-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Cancel List Generation</h2>
      <p>
        Are you sure you want to cancel Florence list generation request of {companyName}?
      </p>
      <div className="action-box">
        <button onClick={previewHandler}>Close</button>
        <button className="delete" onClick={cancelHandler} style={{ minWidth: 130 }}>
          {cancelLoader ? <BeatLoader size={8} color="#fff" /> : "Cancel Request"}
        </button>
      </div>
    </Modal>
  );
};

export default CancelTargetListModal;
